import React from "react";

interface ScrollableContainerProps {
  children: React.ReactNode;
  className?: string;
}

const defaultClassName = "bg-gray-950/95 flex flex-col gap-4 px-5 sm:px-6 py-6";

const ScrollableContainer: React.FC<ScrollableContainerProps> = ({
  children,
  className,
}) => (
  <div className="w-full h-full" translate="no">
    <div className="w-full h-full min-h-0 relative rounded-xl overflow-hidden">
      <div className="row-start-1 row-end-2 min-h-0">
        <div
          className="h-full overflow-y-auto overscroll-contain touch-pan-y"
          style={{ WebkitOverflowScrolling: "touch" }}
        >
          <div
            className={`rounded-xl overflow-hidden shadow-lg border border-white/20 backdrop-blur m-3 sm:m-4 ${
              className || defaultClassName
            }`}
          >
            {children}
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default ScrollableContainer;
